import { ReactNode, useMemo } from 'react';
import objectPath from 'object-path';
import { useHtmlClassService } from '.';
import { HeaderMobile } from './header-mobile/HeaderMobile';
import { Aside } from './aside/Aside';
import { Footer } from './footer/Footer';
import { LayoutInit } from './LayoutInit';
import { SubHeader } from './subheader/SubHeader';
// import { QuickPanel } from "./extras/offcanvas/QuickPanel";
// import { QuickUser } from "./extras/offcanvas/QuickUser";
// import { QuickSearch } from "./extras/offcanvas/QuickSearch";
// import { QuickNotification } from "./extras/offcanvas/QuickNotification";
// import { QuickActions } from "./extras/offcanvas/QuickActions";
import { ScrollTop } from './extras/ScrollTop';
// import { StickyToolbar } from "./extras/StickyToolbar";
// import { AnimateLoading } from "../../_partials/controls";

export function Layout({ children }: { children: ReactNode }) {
    const uiService = useHtmlClassService();
    // Layout settings (cssClasses/cssAttributes)
    const layoutProps = useMemo(() => {
        return {
            selfLayout: objectPath.get(uiService.config, 'self.layout'),
            subheaderDisplay: objectPath.get(uiService.config, 'subheader.display'),
            contentCssClasses: uiService.getClasses('content', true),
            contentContainerClasses: uiService.getClasses('content_container', true),
            contentExtended: objectPath.get(uiService.config, 'content.extended'),
        };
    }, [uiService]);

    return layoutProps.selfLayout !== 'blank' ? (
        <>
            <HeaderMobile />

            <div className="d-flex flex-column flex-root">
                <div className="d-flex flex-row flex-column-fluid page">
                    <Aside />

                    <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
                        <div
                            id="kt_content"
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
                        >
                            {/*<AnimateLoading />*/}
                            {layoutProps.subheaderDisplay && <SubHeader />}

                            {layoutProps.contentExtended && <>{children}</>}

                            {!layoutProps.contentExtended && (
                                <div className="d-flex flex-column-fluid">
                                    <div className={layoutProps.contentContainerClasses}>{children}</div>
                                </div>
                            )}
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            {/*<QuickUser />*/}
            {/*<QuickPanel />*/}
            {/*<QuickNotification />*/}
            <ScrollTop />
            {/*<QuickSearch />*/}
            {/*<QuickActions />*/}
            {/*<StickyToolbar />*/}
            <LayoutInit />
        </>
    ) : (
        <div className="d-flex flex-column flex-root">{children}</div>
    );
}
